import React, { useState } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';

const Search = ({ onSearchchanged }) => {
    const [value, setValue] = useState('');
    const onChange = search => {
        const newValue = search.target.value || ''
        setValue(newValue);
        onSearchchanged(newValue);
    }

    return (
        <form onSubmit={(e) => e.preventDefault()} >
            <TextField 
                id="search" 
                InputProps={{ 
                    inputProps: { tabIndex: -1},
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color='disabled' />
                        </InputAdornment>
                    ),
                }} 
                value={value} 
                placeholder="Rule Search" 
                onChange={onChange} />
            <i className="fas fa-times light" style={{ color: '#ccc' }} onClick={onChange}></i>
        </form>
    );
}

export default Search


// WEBPACK FOOTER //
// ./src/components/Rules/search.js